export default {
  filters: {
    fomatDate(time) {
      let date = new Date(time);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      return `${Y}年-${M}月-${D}日`;
    },
    formatTime(time) {
      let date = new Date(time);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      let h = date.getUTCHours();
      let m = date.getMinutes();
      let s = date.getSeconds();
      let f = num => (num < 10 ? "0" + num : num);
      return `${f(Y)}-${f(M)}-${f(D)} ${f(h)}:${f(m)}:${f(s)}`;
    },
    formatMoney(num) {
      return (num / 100).toFixed(2);
    },
    Fimg(url) {
      return url.replace("img", "http://43.136.85.99/static/img/fresh/product");
    },


  },

  methods: {
    $fail(error) {
      if (error.code == 603) {
        this.$toast.clear();
        return false;
      }
      if (typeof error === "object") {
        this.$toast(error);
        return false;
      }

      this.$toast(error);
    },
    $success(msg) {
      this.$toast.$success(msg);
    },

    $storeCommit(name, payload) {
      let firstLetter = name[0].toUpperCase();
      name = name.replace(/(.)(.*)/, `${firstLetter}$2`);
      this.$store.commit(`update${name}`, payload);
    },

    $get(url, data) {
      return this.$axios.get(url, {
        params: data
      });
    },
    $post(url, data) {
      return this.$axios.post(url, data);
    },
    $loading(flag) {
      if (flag) {
        this.$toast.loading("努力加载中...");
      } else {
        this.$toast.clear();
      }
    }
  }
};